import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";

export const HomeworkList = createAsyncThunk('classDiarySlice/HomeworkList', async (endpoint) => {
    const res = await dataService.GetAPI(endpoint);
    return res;
});

export const NoticesList = createAsyncThunk('classDiarySlice/NoticesList', async (endpoint) => {
    const res = await dataService.GetAPI(endpoint);
    return res;
});

const ClassDiarySlice = createSlice({
    name: 'classDiarySlice',
    initialState: {
        loading: true,
        error: '',
        HomeworkList: {},
        NoticesList: {},
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
        },
    },
    extraReducers: {
        [HomeworkList.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [HomeworkList.fulfilled]: (state, action) => {
            state.loading = false;
            if (action?.payload?.data?.status === 200) {
                state.HomeworkList = action.payload.data.data;
            } else {
                state.error = action?.payload?.data?.message;
            }
        },
        [HomeworkList.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload?.message;
        },
        [NoticesList.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [NoticesList.fulfilled]: (state, action) => {
            state.loading = false;
            if (action?.payload?.data?.status === 200) {
                state.NoticesList = action.payload.data.data;
            } else {
                state.error = action?.payload?.data?.message;
            }
        },
        [NoticesList.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload?.message;
        },
    },
});

export const { setLoading } = ClassDiarySlice.actions;
export default ClassDiarySlice.reducer;
